// Maaş Radar API Endpoints
const API_BASE = process.env.REACT_APP_API_URL || "https://maasradarapi.stechomeyazilim.info";

// Auth
export const POST_JWT_LOGIN = `${API_BASE}/api/Auth/Login`;
export const POST_FAKE_JWT_LOGIN = `${API_BASE}/api/Auth/AdminLogin`;

// Dashboard
export const GET_DASHBOARD_STATS = `${API_BASE}/api/Dashboard/Stats`;
export const GET_DASHBOARD_CHARTS = `${API_BASE}/api/Dashboard/Charts`;

// Users
export const GET_USERS = `${API_BASE}/Users`;
export const GET_USER_DETAIL = (id) => `${API_BASE}/Users(${id})`;
export const UPDATE_USER = (id) => `${API_BASE}/Users(${id})`;
export const DELETE_USER = (id) => `${API_BASE}/Users(${id})`;

// Job Posts
export const GET_JOB_POSTS = `${API_BASE}/JobPosts`;
export const GET_JOB_POST_DETAIL = (id) => `${API_BASE}/JobPosts(${id})`;
export const UPDATE_JOB_POST = (id) => `${API_BASE}/JobPosts(${id})`;

// Companies
export const GET_COMPANIES = `${API_BASE}/Companies`;
export const GET_COMPANY_DETAIL = (id) => `${API_BASE}/Companies(${id})`;
export const UPDATE_COMPANY = (id) => `${API_BASE}/Companies(${id})`;

// Community Posts
export const GET_COMMUNITY_POSTS = `${API_BASE}/CommunityPosts`;
export const GET_COMMUNITY_POST_DETAIL = (id) => `${API_BASE}/CommunityPosts(${id})`;
export const UPDATE_COMMUNITY_POST = (id) => `${API_BASE}/CommunityPosts(${id})`;

// Comments
export const GET_COMMENTS = `${API_BASE}/CommunityPostComments`;
export const GET_COMMENT_DETAIL = (id) => `${API_BASE}/CommunityPostComments(${id})`;
export const UPDATE_COMMENT = (id) => `${API_BASE}/CommunityPostComments(${id})`;

// Salary Entries
export const GET_SALARY_ENTRIES = `${API_BASE}/SalaryEntries`;
export const GET_SALARY_ENTRY_DETAIL = (id) => `${API_BASE}/SalaryEntries(${id})`;

// Reports
export const GET_REPORTED_POSTS = `${API_BASE}/ReportedPosts`;
export const GET_REPORTED_COMMENTS = `${API_BASE}/ReportedComments`;

// Site Settings
export const GET_SITE_SETTINGS = `${API_BASE}/SiteSettings`;
export const GET_SITE_SETTING_DETAIL = (id) => `${API_BASE}/SiteSettings(${id})`;
export const UPDATE_SITE_SETTING = (id) => `${API_BASE}/SiteSettings(${id})`;

// Pages
export const GET_PAGES = `${API_BASE}/Pages`;
export const GET_PAGE_DETAIL = (id) => `${API_BASE}/Pages(${id})`;
export const UPDATE_PAGE = (id) => `${API_BASE}/Pages(${id})`;

// Contact Messages
export const GET_CONTACT_MESSAGES = `${API_BASE}/ContactMessages`;
export const GET_CONTACT_MESSAGE_DETAIL = (id) => `${API_BASE}/ContactMessages(${id})`;

// Premium Plans
export const GET_PREMIUM_PLANS = `${API_BASE}/PremiumPlans`;

// Payments
export const GET_PAYMENTS = `${API_BASE}/Payments`;

// Admin Users
export const GET_ADMIN_USERS = `${API_BASE}/AdminUsers`;

// Professions
export const GET_PROFESSIONS = `${API_BASE}/Professions`;

// Cities
export const GET_CITIES = `${API_BASE}/Cities`;

// Dummy exports for fakebackend_helper.js compatibility
export const POST_FAKE_REGISTER = `${API_BASE}/api/Auth/Register`;
export const POST_FAKE_PASSWORD_FORGET = `${API_BASE}/api/Auth/ForgotPassword`;
export const POST_EDIT_JWT_PROFILE = `${API_BASE}/api/Auth/Profile`;
export const POST_EDIT_PROFILE = `${API_BASE}/api/Auth/Profile`;
export const POST_FAKE_JWT_PASSWORD_FORGET = `${API_BASE}/api/Auth/ForgotPassword`;
export const SOCIAL_LOGIN = `${API_BASE}/api/Auth/SocialLogin`;
export const GET_PRODUCTS = `${API_BASE}/api/Products`;
export const GET_PRODUCTS_DETAIL = `${API_BASE}/api/Products`;
export const GET_GROUPS = `${API_BASE}/api/Groups`;
export const GET_CONTACTS = `${API_BASE}/api/Contacts`;
export const GET_SELECTED_MAILS = `${API_BASE}/api/Mails/Selected`;
export const SET_FOLDER_SELECTED_MAILS = `${API_BASE}/api/Mails/Folder`;
export const GET_ORDERS = `${API_BASE}/api/Orders`;
export const ADD_NEW_ORDER = `${API_BASE}/api/Orders`;
export const UPDATE_ORDER = `${API_BASE}/api/Orders`;
export const DELETE_ORDER = `${API_BASE}/api/Orders`;
export const GET_CART_DATA = `${API_BASE}/api/Cart`;
export const GET_CUSTOMERS = `${API_BASE}/api/Customers`;
export const ADD_NEW_CUSTOMER = `${API_BASE}/api/Customers`;
export const UPDATE_CUSTOMER = `${API_BASE}/api/Customers`;
export const DELETE_CUSTOMER = `${API_BASE}/api/Customers`;
export const GET_SHOPS = `${API_BASE}/api/Shops`;
export const GET_WALLET = `${API_BASE}/api/Wallet`;
export const GET_CRYPTO_ORDERS = `${API_BASE}/api/CryptoOrders`;
export const GET_CRYPTO_PRODUCTS = `${API_BASE}/api/CryptoProducts`;
export const GET_INVOICES = `${API_BASE}/api/Invoices`;
export const GET_INVOICE_DETAIL = `${API_BASE}/api/Invoices`;
export const GET_JOB_LIST = `${API_BASE}/api/JobList`;
export const GET_APPLY_JOB = `${API_BASE}/api/ApplyJob`;
export const GET_PROJECTS = `${API_BASE}/api/Projects`;
export const GET_PROJECT_DETAIL = `${API_BASE}/api/Projects`;
export const GET_TASKS = `${API_BASE}/api/Tasks`;
export const POST_FAKE_LOGIN = `${API_BASE}/api/Auth/Login`;
export const ADD_NEW_JOB_LIST = `${API_BASE}/api/JobList`;
export const UPDATE_JOB_LIST = `${API_BASE}/api/JobList`;
export const DELETE_JOB_LIST = `${API_BASE}/api/JobList`;
export const DELETE_APPLY_JOB = `${API_BASE}/api/ApplyJob`;
export const ADD_NEW_PROJECT = `${API_BASE}/api/Projects`;
export const DELETE_PROJECT = `${API_BASE}/api/Projects`;
export const GET_USER_PROFILE = `${API_BASE}/api/UserProfile`;
export const UPDATE_MAIL = `${API_BASE}/api/Mails`;
export const SELECT_FOLDER = `${API_BASE}/api/Mails/Folder`;
export const ADD_MESSAGE = `${API_BASE}/api/Messages`;
export const GET_WEEKLY_DATA = `${API_BASE}/api/Dashboard/Weekly`;
export const GET_YEARLY_DATA = `${API_BASE}/api/Dashboard/Yearly`;
export const GET_MONTHLY_DATA = `${API_BASE}/api/Dashboard/Monthly`;
export const GET_WALLET_DATA = `${API_BASE}/api/Wallet`;
export const GET_STATISTICS_DATA = `${API_BASE}/api/Statistics`;
export const GET_VISITOR_DATA = `${API_BASE}/api/Visitors`;
export const TOP_SELLING_DATA = `${API_BASE}/api/TopSelling`;
export const GET_EARNING_DATA = `${API_BASE}/api/Earnings`;
export const GET_PRODUCT_COMMENTS = `${API_BASE}/api/ProductComments`;
export const ON_LIKNE_COMMENT = `${API_BASE}/api/Comments/Like`;
export const ON_ADD_REPLY = `${API_BASE}/api/Comments/Reply`;
export const ON_ADD_COMMENT = `${API_BASE}/api/Comments`;

// Dummy exports for fakeBackend.js compatibility
export const ADD_NEW_EVENT = `${API_BASE}/api/Events`;
export const DELETE_EVENT = `${API_BASE}/api/Events`;
export const UPDATE_EVENT = `${API_BASE}/api/Events`;
export const GET_EVENTS = `${API_BASE}/api/Events`;
export const GET_CATEGORIES = `${API_BASE}/api/Categories`;
export const GET_CHATS = `${API_BASE}/api/Chats`;
export const GET_MAILS_LIST = `${API_BASE}/api/Mails`;
export const GET_MESSAGES = `${API_BASE}/api/Messages`;
export const ADD_NEW_USER = `${API_BASE}/api/Users`;
export const UPDATE_PROJECT = `${API_BASE}/api/Projects`;
